import { SolBadge, SolButton, SolIcon } from "@solstice/sol-react";
import { ProfileProps } from "types";
import { Modal } from "ui-molecules";
import { uniqueItems } from "utils";

interface ExpertisePreviousModalProps {
  isOpen: boolean;
  setIsOpen: any;
  profiles: ProfileProps[] | null;
}

const TAGS: { label: string; key: keyof ProfileProps }[] = [
  { label: "Services", key: "services" },
  { label: "Industry", key: "industries" },
  { label: "Property Type", key: "property_types" },
];

const ExpertisePreviousModal: React.FC<ExpertisePreviousModalProps> = ({
  isOpen,
  setIsOpen,
  profiles,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="medium">
      <Modal.Header>
        <div className="w-full flex flex-row justify-between">
          <div className="flex flex-col">
            <h2 className="text-xl">Preview</h2>
          </div>
          <SolButton variant="tertiary" onSol-click={() => setIsOpen(false)}>
            <SolIcon icon="close" />
          </SolButton>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col space-y-4 my-4">
          <p className="">Expertise</p>
          <div className="flex flex-row items-center flex-wrap">
            {TAGS?.map(({ label, key }) => {
              // Collect all items for the current key across all profiles
              const allItems = profiles
                ?.flatMap((profile) => profile[key] || [])
                .filter(Boolean);

              if (!allItems || allItems.length === 0) return null;
              const uniqueItemsList = uniqueItems(allItems, (item) =>
                typeof item === "object" ? item.id || item.name : item
              );
              if (uniqueItemsList.length === 0) return null;
              return (
                <div key={key} className="flex">
                  {uniqueItemsList.map((item, idx) => (
                    <SolBadge
                      key={idx}
                      size="small"
                      variant="filled"
                      className="mb-2 mr-2"
                    >
                      <span>{item?.name || item}</span>
                    </SolBadge>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExpertisePreviousModal;
